/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderResponse } from './LadderResponse';
import {
    LadderResponseFromJSON,
    LadderResponseFromJSONTyped,
    LadderResponseToJSON,
    LadderResponseToJSONTyped,
} from './LadderResponse';

/**
 * 
 * @export
 * @interface CreateLadderResponse
 */
export interface CreateLadderResponse {
    /**
     * 
     * @type {LadderResponse}
     * @memberof CreateLadderResponse
     */
    ladder: LadderResponse;
}

/**
 * Check if a given object implements the CreateLadderResponse interface.
 */
export function instanceOfCreateLadderResponse(value: object): value is CreateLadderResponse {
    if (!('ladder' in value) || value['ladder'] === undefined) return false;
    return true;
}

export function CreateLadderResponseFromJSON(json: any): CreateLadderResponse {
    return CreateLadderResponseFromJSONTyped(json, false);
}

export function CreateLadderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLadderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ladder': LadderResponseFromJSON(json['ladder']),
    };
}

export function CreateLadderResponseToJSON(json: any): CreateLadderResponse {
    return CreateLadderResponseToJSONTyped(json, false);
}

export function CreateLadderResponseToJSONTyped(value?: CreateLadderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ladder': LadderResponseToJSON(value['ladder']),
    };
}

